module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/land-record/land-record.component.html
// module id = ./src/app/planning/land-record/land-record.component.html
// module chunks = main